/**
 * How a page opened inside the FFH app is recognised (useIsAppView). Shared
 * with the ad check that runs before first paint
 * (lib/ads/ad-space-pre-paint.ts), which can't call the hook.
 */

/** Globals the app's WebView injects into the page. */
export const APP_BRIDGE_GLOBALS = [
  'ReactNativeWebView',
  'FantasyFootballHubApp'
] as const;

/** User agent fragments that mark a WebView. */
export const APP_WEBVIEW_USER_AGENT_MARKERS = [
  'wv',
  'WebView',
  'ReactNative'
] as const;

/**
 * Older app builds open pages with ?source=inapp, which is remembered in
 * localStorage for the rest of the visit's pages.
 */
export const APP_SOURCE_QUERY_PARAMETER = 'source';
export const APP_SOURCE_IN_APP = 'inapp';
export const APP_SOURCE_STORAGE_KEY = 'userSource';
